import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { BackgroundColors } from './section-class.types';
import { BACKGROUND_CLASS_MAP } from './section-class.types';

@Pipe({ name: 'sectionBgClass', pure: true })
export class SectionBgClass implements PipeTransform {
	transform(input: BackgroundColors): string {
		return BACKGROUND_CLASS_MAP[input] ?? BACKGROUND_CLASS_MAP['white'];
	}
}
